import Marionette from "marionette";
import TrayBarItemView from "./TrayBarItemView";
import "css!apps/TrayBar/view/css/TrayBarView";


let TrayBarView = Marionette.CollectionView.extend("TrayBarView", {
    className: "TrayBarView no-select",
    childView: TrayBarItemView
});

export default TrayBarView;
